// AppModel.js

import { makeVar } from "@apollo/client";
import UserSessionInfo from "./UserSessionInfo";
import { AppObject, UserClass } from "./AppConst";
import ValueMisc from "./ValueMisc";

export const TickerRepo = makeVar(0); // refreshed every 1 second
export const ThreeDaysRepo=makeVar({yesterday:'', today:'', tomorrow:''}); // for date picker.
export const NoUser = new UserSessionInfo(true);
const NoSessionCheckd = new UserSessionInfo(false); // {...NoUser, sessionChecked: false};
//export const custListRepo = makeVar([]); // for admin only.
export const menuRequestRepo = makeVar(null); // App 어디서든 AppMain으로 메뉴 요청을 보낼 수 있도록.
export const userInfoRepo = makeVar(NoSessionCheckd);
export const codeTreeRepo = makeVar([]); // 로그인하면 한세트 가져옴.
export const codeNameRepo = makeVar({});
export const menuTreeRepo = makeVar([]);
export const mapInitEventRepo = makeVar(null); // {name:'name', data:{}, }
export const currentMenuRepo = makeVar(AppObject.EmptyMenu);
// export const menuTreeRepo = makeVar([]);
export const alertQueueRepo = makeVar([]); // {title:'title', message:[], isError: true}
// ======================== Global Config ========================
export const dcSelectedRepo = makeVar({dcCd:null, dcName:''}); // 많은 화면에서 사용되는 선택된 DC 정보.
// authTree: {proc1: {label, allow:[authClassId1, authClassId2, ...]}, proc2: ...}
// 로그인하면 authTableTreeRepo 가져옴.
export const authTableTreeRepo = makeVar({when:0, tree: {}}); // authTable {jobName:{allow: [authClassId1, authClassId2, .....]}}
export const waveListRepo = makeVar([]); // 배차용 wave 코드 목록. 자주 쓰이므로 미리 만들어 놓기. ('선택'포함)
// @@@@@@@@@@@@@@@@@@@@@@@@ Data general for Admin @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
export const allMenuTreeRepo = makeVar([]); // for admin only.
export const adminMenuTreeRepo = makeVar([]);
export const menuListNotForRepo = makeVar([]);

// @@@@@@@@@@@@@@@@@@@@@@@@ Data for Library @@@@@@@@@@@@@@
// for FlexyTable
export const tableShapeConfRepo = makeVar({}); // veh_pos: {columns:[{id,width}], saved:true}
export const openTableShapeConfRepo = makeVar(false);

// @@@@@@@@@@@@@@@@@@@@@@@@ Data general @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
export const authClassListRepo = makeVar({
    when:0,
    records:Object.values(UserClass)
    .filter(a=>a.rank>0)
    .map((v) => {
        return {authClassId:v.id.toString(), className:v.name, showOnList:true}
    })
}); // authClass
export const commonCodeListRepo = makeVar({when:0, records:[]}); // commonCode (for view)
export const currentPlanStatWithRentListRepo = makeVar({when:0, records:[]}); // currentPlanStatWithRent, VIEW (Home View 현황정보)
export const bbsAnnounceListRepo = makeVar({when:0, records:[]}); // bbsTypeCd='01'
export const bbsVehAllocListRepo = makeVar({when:0, records:[]}); // bbsTypeCd='02'
export const bbsUpdateListRepo = makeVar({when:0, records:[]}); // bbsTypeCd='03'
export const userBbsInfoListRepo = makeVar({when:0, records:[]}); // userBbsInfo
export const userBbsCommentListRepo = makeVar({when:0, records:[]}); // userBbsComment
export const userInfoListRepo = makeVar({when:0, records:[]}); // userInfo
export const userAllocListRepo = makeVar({when:0, records:[]}); // userAlloc
export const dcInfoListRepo = makeVar({when:0, records:[]}); // dcInfo. 로그인하면 한세트 가져옴.
export const dcInfoListWithRentVehCountRepo = makeVar({when:0, records:[]}); // dcInfo
export const dcInfoSelectedWithRentVehCountRepo = makeVar({}); // dcInfo
export const arriveInfoListRepo = makeVar({when:0, records:[]}); // arriveInfo
export const arriveInfoListToSelectStoreRepo = makeVar({when:0, records:[]}); // arriveInfo
export const arriveInfoListForRouteSharingRepo = makeVar({when:0, records:[]}); // arriveInfo
export const arriveInfoListForSettingStoreDidaRepo = makeVar({when:0, records:[]}); // arriveInfo
export const storeInfoListRepo = makeVar({when:0, records:[]}); // storeInfo
export const storeInfoItemRepo = makeVar({when:0, data:{}}); // storeInfo(소속점포)
export const storeInfoListUsingRepo = makeVar({when:0, records:[]}); // storeInfo
export const storeTypeListRepo = makeVar({when:0, records:[]}); // storeType
export const comInfoListRepo = makeVar({when:0, records:[]}); // comInfo
export const comInfoListWithOwnVehCountRepo = makeVar({when:0, records:[]}); // comInfo
export const comInfoSelectedWithOwnVehCountRepo = makeVar({}); // comInfo
export const vehTypeInfoListRepo = makeVar({when:0, records:[]}); // vehTypeInfo
export const vehTypeGroupTreeRepo = makeVar({when:0, records:[]}); // vehTypeGroup
export const vehTypeGroupOrderListRepo = makeVar({when:0, records:[]}); // vehTypeGroupOrder - 차종관리
export const vehTypeGroupOrderAllListRepo = makeVar({when:0, records:[]}); // vehTypeGroupOrder - Select option 그룹에 속하는 모든 차종 목록.
export const vehTypeGroupOrderListByDcRepo = makeVar({when:0, records:[]}); // vehTypeGroupOrder - Select option DC별 차종 목록.
export const vehTypeGroupCodeListRepo = makeVar({when:0, records:[]}); // vehTypeGroupCode
//export const vehTypesInGroupListRepo = makeVar([]); // filtered from vehTypeGroupOrder
//export const vehTypesNotInGroupListRepo = makeVar([]); // filtered from vehTypeGroupOrder
export const vehInfoListAllRepo = makeVar({when:0, records:[]}); // vehInfo
export const vehBanningListRepo = makeVar({when:0, records:[]}); // vehBanning
export const vehInfoListToBanRepo = makeVar({when:0, records:[]}); // vehInfo.
export const vehInfoListOwnedRepo = makeVar({when:0, records:[]}); // vehInfo
export const vehInfoListRentRepo = makeVar({when:0, records:[]}); // vehInfo
export const vehInfoListMyDcRentedRepo = makeVar({when:0, records:[]}); // vehInfo
// fch for FileCreateHis
export const vehInfoListOfDcRepo = makeVar({when:0, records:{}}); // vehInfoListOfDc (rent 무관)
export const fchDeliveryReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 출고실적 리포트 조회
export const fchTransportReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 운송실적 리포트 조회
export const fchArrivalOnTimeReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 정시도착 리포트 조회
export const fchTemperatureReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 온도관제 리포트 조회
export const fchTsrResultReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: TSR결과 리포트 조회
export const fchStoreTransportReportListRepo = makeVar({when:0, records:[]}); // fileCreateHis: 점포운송 리포트 조회
export const autoPlanBindGroupListRepo = makeVar({when:0, records:[]}); // autoPlanBindGroup 동적점포그룹.
export const autoDidaInfoListRepo = makeVar({when:0, records:[], dc:{dcCd:null, dcName:''}}); // autoDidaInfo: 센터별 휴무일 목록.
export const autoDidaInfoCountsRepo = makeVar({when:0, records:[]}); // autoDidaInfo: 센터-요일별 휴무일 수.
export const autoComVehInfoListRepo = makeVar({when:0, records:[], comInfo:{}}); // autoComVehInfo: 운송사 차종 목록.
export const autoUsingCarInfoListRepo = makeVar({when:0, records:[]}); // autoUsingCarInfo: 가용 차량 수 목록.
export const autoUsingCarInfoCacheRepo = makeVar({}); // autoUsingCarInfo: 가용 차량 수 입력을 위한 최종 정보 저장. {dcCd:{date, cache:{vehTypeId:usingCarCnt}}}
export const autoUsingCarInfoParamRepo = makeVar({dcCd:null, planDate:ValueMisc.getYMD(new Date())}); // autoUsingCarInfo: 가용 차량 수 입력을 위한 파라미터 저장.
export const autoCppInfoListRepo = makeVar({when:0, records:[]}); // autoCppInfo, DC별 일일 물동량 볼륨
export const autoCppInfoParamRepo = makeVar({dcCd:null, planDate:ValueMisc.getYMD(ValueMisc.getFirtDateOfMonth())}); // autoCppInfo: DC별 일일 물동량 볼륨 입력을 위한 파라미터 저장.
export const mapPoiAllListRepo = makeVar({when:0, records:[]}); // 지도용 POI 목록. map_poi_all, map_poi_arrival 2개 뷰에 같이 사용. 각각의 뷰가 따로 조회되지 않으므로.
export const rtdTermPosListRepo = makeVar({when:0, records:[]}); // rtdTermPos, 차량별 최종 위치
export const rtdTermPosListNoReportRepo = makeVar({daysAgo:-3, when:0, records:[]}); // rtdTermPosNoReport, 보고누락 차량 조회
export const transPlanListRepo = makeVar({when:0, records:[], filter:{}}); // transPlan, 운송요청 배차내역 테이블(차량관제리스트)
export const vehRouteListRepo = makeVar({when:0, records:[]}); // vehRoute, 경로데이터
export const dcTempBreakHisListRepo
    = makeVar({when:0, records:[], date: ValueMisc.getYMD(new Date()), filter:{}}); // dcTempBreakHis, 차량의 온도 이상 이력
export const dcTempInfoListRepo = makeVar({when:0, records:[]}); // dcTempInfo, DC 별 기준온도 설정
export const transPlanAndActorListRepo = makeVar({when:0, records:[], param:{}, filter:{}}); // transPlanAndActor, 배차현황목록
export const transPlanTravleListRepo = makeVar({planDate:ValueMisc.getYMD(new Date()), dcCd:null, records:[]}); // 배송상태 현황
export const arrivalToStoreListRepo = makeVar({when:0, records:[], param:{dateFrom: ValueMisc.getYMD(), dateTill: ValueMisc.getYMD()}, filter:{}, criteria:{} }); // arrivalToStore, 점포관리.
export const arrivalToStoreFilterRepo = makeVar({}); // arrivalToStore, 점포관리 필터.
export const arrivalToStoreInputStatusRepo = makeVar({open:false, data:{}}); // arrivalToStore, 점포관리 물류집기 입력.
export const transPlanTsrListRepo = makeVar({when:0, records:[]}); // transPlanTsr, VIEW
export const transPlanTsrListParamRepo = makeVar({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanTsrListRepo
export const transPlanLaunchListRepo = makeVar({when:0, records:[]}); // transPlanTsr (launcher list)
export const transPlanLaunchListParamRepo = makeVar({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanLaunchListRepo
export const smsMessageListRepo = makeVar({when:0, records:[], param:{}}); // smsMessage, SMS 전송 기록
export const smsPhrasesListRepo = makeVar({when:0, records:[]}); // smsPhrases, SMS 메시지를 보낼때 자주 사용하는 문구
export const transPlanBindStoreListRepo = makeVar({when:0, records:[]}); // transPlanBindStore, 운송요청 동적 배차내역 (tree)
export const transPlanBindStoreNotBoundListRepo = makeVar({when:0, records:[]}); // transPlanBindStore, 운송요청 동적 배차내역. 동적되지 않은 것들.
export const fchDcTransPlanHistoryFileListRepo = makeVar({when:0, records:[], param:{}}); // DC별 운송요청 이력 파일 목록
export const autoPlanUploadListRepo = makeVar({when:0, records:[]}); // autoPlanUpload, 자동배차 준비 정보
export const autoPlanUploadListParamRepo = makeVar({}); // autoPlanUpload, 자동배차 준비 정보
export const autoPlanBindListRepo = makeVar({when:0, records:[]}); // autoPlanBind, 점포별 동적 정보
export const autoPlanListRepo = makeVar({when:0, records:[]}); // autoPlan, 상온 자동배차
export const autoPlanStateHeaderRepo = makeVar({when:0, data:{}}); // autoPlan, 상온 자동배차 헤더 통계
export const autoRotationHisListRepo = makeVar({when:0, records:[]}); // autoRotationHis, 배차 차종 통계
export const arriveChargeInfoListRepo = makeVar({when:0, records:[], param:{}}); // arriveChargeInfo, DC에서 도착지까지 운임정보
export const bulkCompanyListRepo = makeVar({when:0, records:[], param:{}}); // bulkCompany, Bulk상품 취급업체
export const bulkProductsListRepo = makeVar({when:0, records:[], param:{}}); // bulkProducts, Bulk상품
export const bulkCompanyProductsListRepo = makeVar({when:0, records:[], param:{}}); // bulkCompanyProducts, Bulk Company Products
export const bulkCompanyProductsAllListRepo = makeVar({when:0, records:[], param:{}}); // bulkCompanyProducts, Bulk Company Products

// 승인요청 관련.
export const authClassSimpleListRepo = makeVar([]); // authClassListUnsafe
export const dcInfoSimpleListRepo = makeVar([]); // dcInfoListUnsafe
export const storeInfoSimpleListRepo = makeVar([]); // storeInfoListUnsafe
export const comInfoSimpleListRepo = makeVar([]); // comInfoListUnsafe

// 한시적 설정.
export const showRouteMonthlyActiveOnlyRepo = makeVar(false); // true === totalDist > 0 인 것만 보기.

// for map
export const vehPosRepo = makeVar({when:0, records:[]}); // 수신한 모든 차량위치.
export const vehPosFilteredRepo = makeVar([]); // 수신한 모든 차량위치 필터링된 결과.
export const overlapRepo = makeVar(null); // map shell to MapMain
export const vehPosSearchRepo = makeVar(''); // 차량검색입력.
export const modalWorkRepo = makeVar({}); // arbitrary data for modal work.
export const poiEditCommandRepo = makeVar(null);
export const poiInfoRepo = makeVar([]); // for map
export const naverSearchResultRepo = makeVar([]); 
export const naverSearchRepo = makeVar('');
export const naverRouteRepo = makeVar([]); // 경로탐색 결과. 클래스 NaverRoute

export function clearReposForNewSession() {
    // clear all data which has 'when' property.
    currentPlanStatWithRentListRepo({when:0, records:[]});
    // bbsAnnounceListRepo({when:0, records:[]});
    // bbsVehAllocListRepo({when:0, records:[]});
    // bbsUpdateListRepo({when:0, records:[]});
    // userBbsInfoListRepo({when:0, records:[]});
    // userBbsCommentListRepo({when:0, records:[]});
    userInfoListRepo({when:0, records:[]});
    userAllocListRepo({when:0, records:[]});
    // dcInfoListRepo({when:0, records:[]});
    dcInfoListWithRentVehCountRepo({when:0, records:[]});
    dcInfoSelectedWithRentVehCountRepo({});
    arriveInfoListRepo({when:0, records:[]});
    arriveInfoListToSelectStoreRepo({when:0, records:[]});
    storeInfoListRepo({when:0, records:[]});
    storeInfoListUsingRepo({when:0, records:[]});
    storeTypeListRepo({when:0, records:[]});
    comInfoListRepo({when:0, records:[]});
    comInfoListWithOwnVehCountRepo({when:0, records:[]});
    comInfoSelectedWithOwnVehCountRepo({});
    vehTypeInfoListRepo({when:0, records:[]});
    vehTypeGroupTreeRepo({when:0, records:[]});
    vehTypeGroupOrderListRepo({when:0, records:[]});
    vehTypeGroupOrderListByDcRepo({when:0, records:[]});
    vehTypeGroupCodeListRepo({when:0, records:[]});
    vehBanningListRepo({when:0, records:[]});
    vehInfoListToBanRepo({when:0, records:[]});
    vehInfoListOwnedRepo({when:0, records:[]});
    vehInfoListRentRepo({when:0, records:[]});
    vehInfoListMyDcRentedRepo({when:0, records:[]});
    vehInfoListOfDcRepo({when:0, records:{}}); // records:{comId: [vehInfo]}
    fchDeliveryReportListRepo({when:0, records:[]});
    fchTransportReportListRepo({when:0, records:[]});
    fchArrivalOnTimeReportListRepo({when:0, records:[]});
    fchTemperatureReportListRepo({when:0, records:[]});
    fchTsrResultReportListRepo({when:0, records:[]});
    fchStoreTransportReportListRepo({when:0, records:[]}); // fileCreateHis: 점포운송 리포트 조회
    vehPosRepo({when:0, records:[]}); // 수신한 모든 차량위치.
    autoPlanBindGroupListRepo({when:0, records:[]}); // autoPlanBindGroup 동적점포그룹.
    autoDidaInfoListRepo({when:0, records:[], dc:{dcCd:null, dcName:''}}); // autoDidaInfo: 센터별 휴무일 목록.
    autoDidaInfoCountsRepo({when:0, records:[]}); // autoDidaInfo: 센터-요일별 휴무일 수.
    autoComVehInfoListRepo({when:0, records:[], comInfo:{}}); // 운송사 차종 목록.
    autoUsingCarInfoListRepo({when:0, records:[]}); // 가용 차량 수 목록.
    autoUsingCarInfoCacheRepo({}); // 가용 차량 수 최종 값. backup.
    autoUsingCarInfoParamRepo({dcCd:null, planDate:ValueMisc.getYMD(new Date())}); // 가용 차량 수 입력을 위한 파라미터 저장.
    autoCppInfoListRepo({when:0, records:[]}); // DC별 일일 물동량 볼륨
    autoCppInfoParamRepo({dcCd:null, planDate:ValueMisc.getYMD(ValueMisc.getFirtDateOfMonth())}); // DC별 일일 물동량 볼륨 입력을 위한 파라미터 저장.
    mapPoiAllListRepo({when:0, records:[]}); // 지도용 POI 목록.
    rtdTermPosListRepo({when:0, records:[]}); // 차량별 최종 위치
    transPlanListRepo({when:0, records:[], filter:{}}); // 운송요청 배차내역 테이블. 차량관제리스트.
    vehRouteListRepo({when:0, records:[]}); // vehRoute, 경로데이터
    dcTempBreakHisListRepo({when:0, records:[], date: ValueMisc.getYMD(new Date()), filter:{}}); // 차량의 온도 이상 이력
    transPlanAndActorListRepo({when:0, records:[], param:{}, filter:{}}); // 배차현황목록
    arrivalToStoreListRepo({when:0, records:[], param:{dateFrom: ValueMisc.getYMD(), dateTill: ValueMisc.getYMD()}, filter:{}, criteria:{}}); // arrivalToStore, 점포관리.
    arrivalToStoreInputStatusRepo({open:false, data:{}}); // arrivalToStore, 점포관리 물류집기 입력.
    transPlanTsrListRepo({when:0, records:[], param:{}}); // VIEW
    transPlanTsrListParamRepo({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanTsrListRepo
    transPlanLaunchListRepo({when:0, records:[]}); // transPlanTsr (launcher list)
    transPlanLaunchListParamRepo({dcCd:null, storeId:null, planDate:ValueMisc.getYMD()}); // for transPlanLaunchListRepo
    smsMessageListRepo({when:0, records:[], param:{}}); // SMS 전송 기록
    smsPhrasesListRepo({when:0, records:[] }); // SMS 메시지를 보낼때 자주 사용하는 문구
    transPlanBindStoreListRepo({when:0, records:[]}); // 운송요청 동적 배차내역 (tree)
    transPlanBindStoreNotBoundListRepo({when:0, records:[]}); // 운송요청 동적 배차내역. 동적되지 않은 것들.
    fchDcTransPlanHistoryFileListRepo({when:0, records:[], param:{}}); // DC별 운송요청 이력 파일 목록
    autoPlanUploadListRepo({when:0, records:[]}); // 자동배차 준비 정보
    autoPlanUploadListParamRepo({});
    autoPlanBindListRepo({when:0, records:[]}); // 점포별 동적 정보
    autoPlanListRepo({when:0, records:[]}); // 상온 자동배차
    autoPlanStateHeaderRepo({when:0, data:{}}); // 상온 자동배차 헤더 통계
    autoRotationHisListRepo({when:0, records:[]}); // 배차 차종 통계
    arriveChargeInfoListRepo({when:0, records:[], param:{}}); // DC에서 도착지까지 운임정보
    bulkCompanyListRepo({when:0, records:[], param:{}}); // Bulk 상품 취급업체
    bulkProductsListRepo({when:0, records:[], param:{}}); // Bulk 상품
    bulkCompanyProductsListRepo({when:0, records:[], param:{}}); // Bulk Company Products
    bulkCompanyProductsAllListRepo({when:0, records:[], param:{}}); // Bulk Company Products
}
